import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {MO_LIST_PAGE} from '../../common/constants/Pages.js'
import {MO_PLURAL_URI_COMPONENT} from '../../common/constants/MOs.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {setupMOListForm} from './moListActions.js'

export default function MOListLocationListener() {
  const {
    pathComponents: [resource],
  } = useSelector(locationSelector)
  const isThisPage = resource === MO_PLURAL_URI_COMPONENT

  useEffect(() => {
    setupMOListForm()
  }, [])

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(MO_LIST_PAGE))
  }, [isThisPage])

  return null
}
